import React from 'react';
import { useLocale } from 'locale';
import { PoiId } from 'utils/entities';
import { ShareButton } from 'components/navigation/share/ShareButton';
import { Button } from 'ds/components/button';
import TrashIcon from 'assets/svg/trash-1-5.svg';
import ShareIcon from 'assets/svg/share.svg';
import { CardWithControlsButtonWrapper, CardWithControlsRemoveButtonWrapper } from './styled';
import { connect } from 'react-redux';
import { setContactAgentOpen } from 'store/state/app/actions';
import { ContactAgentModalSource, ContactModalOpenMeta } from 'store/state/app';
import { ShareType } from 'helpers/share-helpers';

interface ControlsProps {
  isInactive: boolean;
  id: PoiId;
  onSetContactModalPoiId: (id: PoiId, meta: ContactModalOpenMeta) => void;
  handleShare: (type: ShareType) => void;
  copyText: string;
  agentText: string;
}

const Controls: React.FC<ControlsProps> = ({
  isInactive,
  id,
  handleShare,
  copyText,
  agentText,
  onSetContactModalPoiId,
}) => {
  const { t } = useLocale();
  const followUpHandler = () => onSetContactModalPoiId(id, { source: ContactAgentModalSource.ContactSection });

  const shouldResetSelectedValue = () => true;
  const shouldStayOpen = (value: ShareType) => value === ShareType.CopyLink;

  return (
    <div className="saved-list-card-buttons-wrapper">
      {isInactive ? (
        <CardWithControlsRemoveButtonWrapper>
          <Button fullWidth>
            <TrashIcon />
            {t('listingCard.remove')}
          </Button>
        </CardWithControlsRemoveButtonWrapper>
      ) : (
        <>
          <CardWithControlsButtonWrapper className="saved-list-card-button">
            <Button data-auto="button-contact-seller" fullWidth onClick={followUpHandler}>
              {agentText}
            </Button>
          </CardWithControlsButtonWrapper>
          <CardWithControlsButtonWrapper className="saved-list-card-button">
            <ShareButton
              poiId={id}
              shouldResetSelectedValue={shouldResetSelectedValue}
              shouldStayOpen={shouldStayOpen}
              handleShare={handleShare}
              verticalPosition="top"
              copyText={copyText}
            >
              <Button data-auto="button-share" mode="ghost" fullWidth>
                <ShareIcon width={16} height={16} />
                {t('listingCard.share')}
              </Button>
            </ShareButton>
          </CardWithControlsButtonWrapper>
        </>
      )}
    </div>
  );
};

export default connect(null, { onSetContactModalPoiId: setContactAgentOpen })(Controls);
